import React, { useState } from 'react';
import { Modal, Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import axios from 'axios';

const ValidateModal = ({ open, onClose, onValidate, userId, fetchData }) => {
  const [formData, setFormData] = useState({
    ShopAndPanImage: false,
    certificateOfIncorporationImage: false,
    tradeBusinessProof: false,
    cancelledChequeImages: false,
    physicalVerification: false,
    videoKycWithLatLongData: false,
  });

  const handleCheckboxChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.checked,
    });
  };

  // Check if all checkboxes are checked
  const allChecked = Object.values(formData).every((value) => value === true);

  const handleValidateClick = async () => {
    try {
      const response = await axios.put('https://api.ipaisa.co.in/myapp/admin/updateCmsApplication', {
        ...formData,
        userId: userId,
      });

      onClose(); // Close the modal
      fetchData();
      if (response.data.statusCodeValue === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: response.data.body.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: response.data.body.message,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.response?.data?.body?.message,
      });
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Validate Application
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                name="ShopAndPanImage"
                checked={formData.ShopAndPanImage}
                onChange={handleCheckboxChange}
              />
            }
            label="Shop and Pan Image"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="certificateOfIncorporationImage"
                checked={formData.certificateOfIncorporationImage}
                onChange={handleCheckboxChange}
              />
            }
            label="Certificate of Incorporation Image"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="tradeBusinessProof"
                checked={formData.tradeBusinessProof}
                onChange={handleCheckboxChange}
              />
            }
            label="Trade Business Proof"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="cancelledChequeImages"
                checked={formData.cancelledChequeImages}
                onChange={handleCheckboxChange}
              />
            }
            label="Cancelled Cheque Images"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="physicalVerification"
                checked={formData.physicalVerification}
                onChange={handleCheckboxChange}
              />
            }
            label="Physical Verification"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="videoKycWithLatLongData"
                checked={formData.videoKycWithLatLongData}
                onChange={handleCheckboxChange}
              />
            }
            label="Video KYC with Lat Long Data"
          />
        </Box>
        {/* Note for mandatory checks */}
        <Typography variant="body2" sx={{ mt: 2, color: 'error.main' }}>
          * All checks are mandatory.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleValidateClick}
            disabled={!allChecked} // Disable button if not all checkboxes are checked
          >
            Validate
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ValidateModal;
